module.exports = __webpack_public_path__ + "img/elementwidths_jak.a3d57150.png";